import { email, pdfCommissions, pdfTraining1, pdfTraining2 } from '@/config'

const referralLink = 'https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fsn%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.sn%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral'

const dashboardGetUpdatedItems = [
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    link: 'https://www.facebook.com/groups/1346470792157416/',
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
   {
    img: 'img/dashboard/contact-form.svg',
    title: {
      key: 'dashboard.claim_form.title'
    },
    subtitle: {
      text: 'dashboard.claim_form.subtitle',
      isKey: true
    },
    link: 'https://docs.google.com/forms/d/1osOYBdnnBthWQsN10ZdXlp9cGuqed1FaLy3gTmzvbmk/edit?usp=forms_home&ths=true',
    newPage: true
  },
  {
    img: 'img/dashboard/whatsapp.svg',
    title: {
      key: 'dashboard.contact.whatsapp'
    },
    link: 'https://chat.whatsapp.com/DRGJfuJ5XYM7oDpuAjyPYM',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    subtitle: {
      text: '',
      isKey: false
    },
    link: 'https://www.facebook.com/groups/1346470792157416/',
    newPage: true
  }
]

const dashboardOtherItems = [
  {
    disabled: false,
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      text: 'Grille de commission et niveaux'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'JForce Training'
    },
    link: pdfTraining1,
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
